import { Box, Grid, GridItem, Text, Heading, RadioGroup, Radio, Stack, List, ListItem, UnorderedList } from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import { getInsightsForJourneys } from '../../utilities/journeyAnalysisHelper';

import { CountriesVisitedInsightsPanelItem, DurationInsightsPanelItem, InternationalTravelInsightsPanelItem, LongestJourneysInsightsPanelItem, ShortestJourneysInsightsPanelItem, StationCountryBreakdownInsightsPanelItem, StationsVisitedInsightsPanelItem, SummaryInsightsPanelItem, TopRoutesInsightsPanelItem } from './InsightsPanelDefinedItems';


export default function InsightsPanel({ journeys, homeCountryCode }) {

    const [dataToDisplay, setDataToDisplay] = useState(undefined)

    useEffect(() => {
        if (!journeys)
            return

        setDataToDisplay(getInsightsForJourneys(journeys, homeCountryCode))
    }, [journeys])

    if (!dataToDisplay) {
        return (<></>)
    }

    return (
        <>
            <Box p={4} borderWidth="1px" borderRadius="lg" height="100%">
                <Grid
                    templateColumns={{ base: "repeat(1, 1fr)", md: "repeat(2, 1fr)", lg: "repeat(3, 1fr)" }}
                    gap={6}
                    height="100%"
                >
                    {/* 1x1 */}
                    <SummaryInsightsPanelItem
                        noOfJourneys={dataToDisplay.noOfJourneys}
                        totalDistance={dataToDisplay.totalDistance}
                        averageDistance={dataToDisplay.averageDistance}
                        timesAroundTheWorld={dataToDisplay.timesAroundTheWorld}
                        timesToTheMoon={dataToDisplay.timesToTheMoon}
                    />

                    {/* 2x1 */}
                    <DurationInsightsPanelItem
                        totalDuration={dataToDisplay.totalDuration}
                        averageDuration={dataToDisplay.averageDuration}
                        fullyFormattedDuration={dataToDisplay.fullyFormattedDuration}
                        isolatedMinutesDuration={dataToDisplay.isolatedMinutesDuration}
                        isolatedHoursDuration={dataToDisplay.isolatedHoursDuration}
                        isolatedDaysDuration={dataToDisplay.isolatedDaysDuration}
                        isolatedWeeksDuration={dataToDisplay.isolatedWeeksDuration}
                        isolatedMonthsDuration={dataToDisplay.isolatedMonthsDuration}
                    />

                    {/* 3x1 */}
                    <StationsVisitedInsightsPanelItem
                        noOfStationsVisited={dataToDisplay.noOfStationsVisited}
                        topStations={dataToDisplay.topStations}
                    />

                    {/* 1x2 */}
                    <TopRoutesInsightsPanelItem
                        topRoutes={dataToDisplay.topRoutes}
                    />

                    {/* 2x2 */}
                    <LongestJourneysInsightsPanelItem
                        longestDistanceJourneys={dataToDisplay.longestDistanceJourneys}
                        longestDurationJourneys={dataToDisplay.longestDurationJourneys}
                    />

                    {/* 3x2 */}
                    <ShortestJourneysInsightsPanelItem
                        shortestDistanceJourneys={dataToDisplay.shortestDistanceJourneys}
                        shortestDurationJourneys={dataToDisplay.shortestDurationJourneys}
                    />

                    {/* 1x3 */}
                    <CountriesVisitedInsightsPanelItem
                        noOfCountriesVisitedByRail={dataToDisplay.noOfCountriesVisitedByRail}
                        countriesVisitedByRail={dataToDisplay.countriesVisitedByRail}
                    />

                    {/* 2x3 */}
                    <InternationalTravelInsightsPanelItem
                        noOfJourneysWithinHomeCountry={dataToDisplay.noOfJourneysWithinHomeCountry}
                        noOfJourneysToOrFromAbroad={dataToDisplay.noOfJourneysToOrFromAbroad}
                        noOfJourneysOutsideHomeCountry={dataToDisplay.noOfJourneysOutsideHomeCountry}
                        distanceWithinHomeCountry={dataToDisplay.distanceWithinHomeCountry}
                        distanceToOrFromAbroad={dataToDisplay.distanceToOrFromAbroad}
                        distanceOutsideHomeCountry={dataToDisplay.distanceOutsideHomeCountry}
                        durationWithinHomeCountry={dataToDisplay.durationWithinHomeCountry}
                        durationToOrFromAbroad={dataToDisplay.durationToOrFromAbroad}
                        durationOutsideHomeCountry={dataToDisplay.durationOutsideHomeCountry}
                    />

                    {/* 3x3 */}
                    <StationCountryBreakdownInsightsPanelItem
                        noOfStationsVisitedInHomeCountry={dataToDisplay.noOfStationsVisitedInHomeCountry}
                        noOfStationsVisitedAbroad={dataToDisplay.noOfStationsVisitedAbroad}
                    />
                </Grid>
            </Box>
        </>
    );
}